<template>

  <v-card class="stayCard">
    <v-navigation-drawer absolute temporary :right="true" v-model="isAlertsDrawerVisible" v-if="isAlertsDrawerVisible">

      <v-layout>
        <v-flex>
          <div class="ntstSectionTitle legendSectionHeader">Alerts</div>
        </v-flex>
      </v-layout>
      <v-divider class="legendDivider"></v-divider>
      <v-flex v-for="(code, index) of getAlertCodes()" :key="`asc-${index}`" :style="getAlertStyle(code)" @click="toggleAlert(code)">
        <alert-visualized-coded-entry class="alert legendItemIcon" :visualized-coded-entry="code"></alert-visualized-coded-entry>
        <span class="legendItemText">{{ code.displayName }}</span>
      </v-flex>

    </v-navigation-drawer>
    <v-card-title>
      <v-layout row>
        <span class="clientStatusAndImage">
          <v-layout row>
            <span :style="dischargeStatusBarStyle"></span>
            <v-avatar class="clientAvatar" :size="'64px'">
              <client-image :clientID="stay.clientSummary.clientID.id" :clientName="stay.clientSummary.clientName" />
            </v-avatar>
          </v-layout>
        </span>
        <span>
          <div>
            <div class="clientContainer">
              <span class="clientText">{{ clientText }}</span>
              <span v-if="alerts" v-for="(code, index) of alerts" :key="index">
                <alert-visualized-coded-entry class="alert" :visualized-coded-entry="code" :alertDisplayName="getAlertDisplayName(code)"></alert-visualized-coded-entry>
              </span>
            </div>
            <div class="ntstValueLabel">Attending Physician</div>
            <div class="ntstValue">{{attendingPhysicianName}}</div>
          </div>
        </span>
      </v-layout>

      <v-spacer></v-spacer>

      <v-btn v-if="isEditable && isActionable" class="ntstAppButton" @click.stop="toogleAlertsDrawer()">Toggle Alerts</v-btn>
      <v-btn v-if="isCloseVisible" xs icon @click.stop="cancel()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text :style="cardTextStyle">

      <v-layout row>
        <v-flex v-if="isActionable">
          <div class="ntstValueLabel">Discharge Status</div>
          <v-select v-if="isEditable && isActionable" :disabled="!(isEditable && isActionable)" class="staySelector" v-model="dischargeStatusCodeValue" :items="dischargeStatusCodes" outline item-value="code" item-text="displayName"></v-select>
          <div v-if="!(isEditable && isActionable)">{{ dischargeStatusCodeDisplayName }}</div>
        </v-flex>
        <v-flex v-if="!isActionable">
          <div class="ntstValueLabel">Reservation Status</div>
          <div class="ntstValue">{{ reservationStatusCodeDisplayName }}</div>
        </v-flex>
        <v-flex>
          <div class="ntstValueLabel">Room Assignment</div>
          <div class="ntstValue">{{room.name}}</div>
        </v-flex>

        <v-flex v-if="availableBeds">
          <div class="ntstValueLabel">Bed Assignment</div>
          <v-select v-if="isEditable && isActionable" :disabled="!(isEditable && isActionable)" class="staySelector" v-model="bedIDValue" :items="availableBeds" item-value="bedBoardBedID.id" outline item-text="name"></v-select>
          <div v-if="!(isEditable && isActionable) ">{{ bedName }}</div>
        </v-flex>
      </v-layout>

      <div class="ntstSectionTitle" style="margin-top: 6px;">Client Details</div>

      <v-divider></v-divider>

      <v-layout row class="clientDetailsRow">
        <v-flex xs6>
          <div class="ntstValueLabel">Emergency Contact</div>
          <div class="ntstValue">{{emergencyContact}}</div>
        </v-flex>
        <v-flex xs6>
          <div class="ntstValueLabel">Allergies</div>
          <div class="ntstValue">{{allergies}}</div>
        </v-flex>
      </v-layout>
      <v-layout row class="clientDetailsRow">
        <v-flex xs6>
          <div class="ntstValueLabel">Alias</div>
          <div class="ntstValue">{{alias}}</div>
        </v-flex>
        <v-flex xs6>
          <div class="ntstValueLabel">DOB</div>
          <div v-if="dob" class="ntstValue">{{dob|moment('MM/DD/YYYY')}}</div>
        </v-flex>
      </v-layout>

      <v-layout row class="clientDetailsRow">
        <v-flex xs6>
          <div class="ntstValueLabel">Primary Dx</div>
          <div class="ntstValue">{{primaryDx}}</div>
        </v-flex>
        <v-flex xs6>
          <div class="ntstValueLabel">Admission Date</div>
          <div v-if="admissionDate" class="ntstValue">{{admissionDate|moment('MM/DD/YYYY')}}</div>
        </v-flex>
      </v-layout>
      <v-layout row class="clientDetailsRow">
        <v-flex xs6>
          <div class="ntstValueLabel">Treatment Team</div>
          <div class="ntstValue">{{treatmentTeam}}</div>
        </v-flex>
        <v-flex xs6 v-if="isActionable">
          <div class="ntstValueLabel">Race</div>
          <div class="ntstValue">{{races}}</div>
        </v-flex>
        <v-flex v-if="!isActionable">
          <div class="ntstValueLabel">Reservation Information</div>
          <div class="ntstValue">{{ stay.reservationDescription }}</div>
        </v-flex>
      </v-layout>
      <v-layout row class="clientDetailsRow">
        <v-flex xs6>
          <div class="ntstValueLabel">{{ guarantorLabel }}</div>
          <div class="ntstValue">{{ guarantorDescription }}</div>
        </v-flex>
        <v-flex xs6 v-if="!isActionable">
          <div class="ntstValueLabel">Race</div>
          <div class="ntstValue">{{races}}</div>
        </v-flex>
      </v-layout>

      <v-layout v-if="unit.isGuardianVisible" row class="clientDetailsRow">
        <v-flex xs6>
          <div class="ntstValueLabel">{{ guardianLabel }}</div>
          <div class="ntstValue">{{ guardianDescription }}</div>
        </v-flex>
      </v-layout>

      <div class="ntstSectionTitle">Next Med Admin Time</div>

      <v-divider></v-divider>

      <v-layout row class="clientDetailsRow">
        <v-flex xs6>
          <div class="ntstValueLabel">{{ nextMedAdminTime }}</div>
          <div class="ntstValue">{{ nextMedAdminMedication }}</div>
        </v-flex>
      </v-layout>

      <div class="ntstSectionTitle">Staff Notes</div>
      <v-divider></v-divider>
      <v-textarea outline name="input-7-4" v-model="stay.staffNotes" :readonly="!isStaffNotesEditable || !isActionable"></v-textarea>

    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions v-if="isActionable && (isEditable || isStaffNotesEditable)">
      <v-spacer></v-spacer>
      <v-btn class="ntstAppButton" @click.stop="cancel()">
        Cancel
      </v-btn>

      <v-btn class="ntstAppButton" @click.stop="save()">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment';
import AlertVisualizedCodedEntry from './AlertVisualizedCodedEntry.vue';
import ClientImage from './ClientImage.vue';

export default {
  name: 'StayCard',
  data() {
    return {
      isAlertsDrawerVisible: false
    };
  },
  props: {
    isEditable: { default: false, type: Boolean },
    isCloseVisible: { default: true, type: Boolean },
    isShowingInRoomCard: { default: false, type: Boolean },
    isStaffNotesEditable: { default: true, type: Boolean },
    onCancel: Function,
    onSave: Function,
    room: Object,
    stay: Object,
    unit: Object
  },
  components: {
    'alert-visualized-coded-entry': AlertVisualizedCodedEntry,
    'client-image': ClientImage
  },
  computed: {
    admissionDate() {
      let returnValue = null;
      if (this.stay && this.stay.clientSummary) {
        returnValue = this.stay.clientSummary.admissionDate;
      }
      return returnValue;
    },

    alerts() {
      let returnValue = [];
      if (this.stay && this.stay.bedBoardAlerts) {
        returnValue = this.$store.getters.getStandardAssignedAlertCodes(this.stay.bedBoardAlerts);
      }
      return returnValue;
    },
    allergies() {
      let returnValue = null;
      if (this.stay && this.stay.clientSummary) {
        returnValue = this.stay.clientSummary.allergiesDescription;
      }
      return returnValue;
    },
    alias() {
      let returnValue = null;
      if (this.stay && this.stay.clientSummary) {
        returnValue = this.stay.clientSummary.aliasDescription;
      }
      return returnValue;
    },
    attendingPhysicianName() {
      let returnValue = null;
      if (
        this.stay
        && this.stay.clientSummary
        && this.stay.clientSummary.attendingPhysicianName
      ) {
        returnValue = this.stay.clientSummary.attendingPhysicianName.last;

        returnValue = `${this.stay.clientSummary.attendingPhysicianName
          .prefix || ''} ${this.stay.clientSummary.attendingPhysicianName
          .first || ''} ${this.stay.clientSummary.attendingPhysicianName.last
          || ''} ${this.stay.clientSummary.attendingPhysicianName.suffix
          || ''}`.trim();
      }
      return returnValue;
    },
    availableBeds() {
      return this.$store.getters.getAvailableBeds(
        this.room.bedBoardRoomID,
        this.stay.bedBoardStayID
      );
    },

    bedIDValue: {
      get() {
        let returnValue = null;
        if (this.stay && this.stay.bedID) {
          returnValue = this.stay.bedID.id;
        }
        return returnValue;
      },
      set(newValue) {
        if (this.stay) {
          if (this.stay.bedID) {
            this.stay.bedID.id = newValue;
          } else {
            this.stay.bedID = { id: newValue };
          }
        }
      }
    },
    bedName() {
      let returnValue = null;
      if (this.room.beds && this.stay.bedID) {
        const bed = this.room.beds.find(b => b.bedBoardBedID.id === this.stay.bedID.id);
        if (bed) {
          returnValue = bed.name;
        }
      }
      return returnValue;
    },
    cardTextStyle() {
      let returnValue = null;

      if (!this.isShowingInRoomCard) {
        returnValue = {
          height: 'calc(90vh - 220px)',
          overflowY: 'auto'
        };
      } else {
        returnValue = {
          height: 'calc(90vh - 320px)',
          overflowY: 'auto'
        };
      }

      return returnValue;
    },
    clientText() {
      let returnValue = null;
      if (this.stay.clientSummary && this.stay.clientSummary.clientName) {
        let age = '-';
        if (this.stay.clientSummary.birthDate) {
          age = moment().diff(this.stay.clientSummary.birthDate, 'years');
        }
        let gender = '-';
        if (this.stay.clientSummary.genderDescription) {
          gender = this.stay.clientSummary.genderDescription;
        }
        returnValue = `${
          this.stay.clientSummary.clientName.first
        } ${this.stay.clientSummary.clientName.last.charAt(0)}. (${age}, ${gender})`;
      }
      return returnValue;
    },
    dischargeStatusCodes() {
      return this.$store.getters.dischargeStatusCodes;
    },
    dischargeStatusCodeDisplayName() {
      let returnValue = null;
      if (this.stay && this.stay.dischargeStatusCode) {
        const visualizedCodedEntry = this.$store.getters.getDischargeStatusCode(this.stay.dischargeStatusCode);
        returnValue = visualizedCodedEntry.displayName;
      }
      return returnValue;
    },
    dischargeStatusBarStyle() {
      let returnValue = null;
      if (this.stay && this.stay.dischargeStatusCode) {
        const visualizedCodedEntry = this.$store.getters.getDischargeStatusCode(this.stay.dischargeStatusCode);
        if (visualizedCodedEntry) {
          returnValue = {
            borderColor: visualizedCodedEntry.backgroundColorHexValue
              ? visualizedCodedEntry.backgroundColorHexValue
              : '#ffffff',
            borderStyle: 'solid',
            borderLeftWidth: '3px',
            height: '65px',
            marginRight: '5px'
          };
        }
      }
      return returnValue;
    },
    dischargeStatusCodeValue: {
      get() {
        let returnValue = null;
        if (this.stay && this.stay.dischargeStatusCode) {
          returnValue = this.stay.dischargeStatusCode.code;
        }
        return returnValue;
      },
      set(newValue) {
        if (this.stay) {
          if (this.stay.dischargeStatusCode) {
            this.stay.dischargeStatusCode.code = newValue;
          } else {
            this.stay.dischargeStatusCode = { code: newValue };
          }
        }
      }
    },
    dob() {
      let returnValue = null;
      if (
        this.stay
        && this.stay.clientSummary
        && this.stay.clientSummary.birthDate
      ) {
        returnValue = moment(this.stay.clientSummary.birthDate);
      }
      return returnValue;
    },
    emergencyContact() {
      let returnValue = null;
      if (
        this.stay
        && this.stay.clientSummary
        && this.stay.clientSummary.emergencyContactName
      ) {
        const name = `${this.stay.clientSummary.emergencyContactName.first
          || ''} ${this.stay.clientSummary.emergencyContactName.last
          || ''}`.trim();

        let number = '';
        if (this.stay.clientSummary.emergencyContactPhoneNumber) {
          number = this.stay.clientSummary.emergencyContactPhoneNumber.number;
        }

        returnValue = `${name || ''} ${number || ''}`;
      }
      return returnValue;
    },
    guarantorDescription() {
      let returnValue = null;
      if (this.stay && this.stay.clientSummary) {
        returnValue = this.stay.clientSummary.guarantorDescription;
      }
      return returnValue;
    },
    guardianDescription() {
      let returnValue = null;
      if (this.stay && this.stay.clientSummary) {
        returnValue = this.stay.clientSummary.guardianDescription;
      }
      return returnValue;
    },
    guarantorLabel() {
      return this.unit.guarantorLabel || 'Payor';
    },
    guardianLabel() {
      let returnValue = 'Guardian';
      if (this.stay && this.stay.clientSummary) {
        returnValue = this.stay.clientSummary.guardianLabel;
      }
      return returnValue;
    },
    isActionable() {
      return this.$store.getters.isStayActionable(this.stay);
    },
    maritalStatus() {
      let returnValue = null;
      if (this.stay && this.stay.clientSummary) {
        returnValue = this.stay.clientSummary.maritalStatusDescription;
      }
      return returnValue;
    },
    nextMedAdminTime() {
      let returnValue = null;
      if (
        this.stay
        && this.stay.clientSummary
        && this.stay.clientSummary.nextMedicationAdministrationDate
      ) {
        const date = moment(this.stay.clientSummary.nextMedicationAdministrationDate);
        returnValue = date.format('h:mm a');
        if (date.diff(moment(), 'DAYS') !== 0) {
          returnValue = date.format('M/D/YYYY h:mm a');
        }
      }
      return returnValue;
    },
    nextMedAdminMedication() {
      let returnValue = null;
      if (this.stay && this.stay.clientSummary) {
        returnValue = this.stay.clientSummary
          .nextMedicationAdministrationDescription;
      }
      return returnValue;
    },
    primaryDx() {
      let returnValue = null;
      if (this.stay && this.stay.clientSummary) {
        returnValue = this.stay.clientSummary.primaryDxDescription;
      }
      return returnValue;
    },
    races() {
      let returnValue = null;
      if (this.stay && this.stay.clientSummary) {
        returnValue = this.stay.clientSummary.primaryRaceDescription;
      }
      return returnValue;
    },
    reservationStatusCodeDisplayName() {
      let returnValue = null;
      if (this.stay && this.stay.reservationStatusCode) {
        returnValue = this.stay.reservationStatusCode.displayName;
      }
      return returnValue;
    },

    treatmentTeam() {
      let returnValue = null;
      if (this.stay && this.stay.clientSummary) {
        returnValue = this.stay.clientSummary.treatmentTeamDescription;
      }
      return returnValue;
    }
  },
  methods: {
    cancel() {
      this.onCancel();
    },
    getAlertCodes() {
      return this.$store.getters.alertCodes;
    },
    getAlertDisplayName(standardCode) {
      let returnValue = standardCode.displayName;
      const match = this.stay.bedBoardAlerts.find(w => w.code === standardCode.code);
      if (match && match.displayName) {
        returnValue = match.displayName;
      }
      return returnValue;
    },
    getAlertStyle(code) {
      let returnValue = 'background-color: #fff; border: 1px solid #fff; cursor: default;';
      if (
        code
        && this.stay.bedBoardAlerts
        && this.stay.bedBoardAlerts.find(alert => alert.code === code.code)
      ) {
        returnValue = 'background-color: #f2f2f2; border: 1px solid #cccccc; cursor: default;';
      }

      return returnValue;
    },
    save() {
      this.onSave(this.stay);
    },
    toggleAlert(code) {
      if (code) {
        if (this.stay.bedBoardAlerts && this.stay.bedBoardAlerts.length > 0) {
          const existingAlertIndex = this.stay.bedBoardAlerts
            .map(alert => alert.code)
            .indexOf(code.code);
          if (existingAlertIndex > -1) {
            this.stay.bedBoardAlerts.splice(existingAlertIndex, 1);
          } else {
            this.stay.bedBoardAlerts.push(code);
          }
        } else {
          this.stay.bedBoardAlerts = [];
          this.stay.bedBoardAlerts.push(code);
        }
      }
    },
    toogleAlertsDrawer() {
      this.isAlertsDrawerVisible = !this.isAlertsDrawerVisible;
    }
  }
};
</script>

<style lang="scss">
.clientAvatar {
  margin-right: 5px;
  vertical-align: top;
}
.clientContainer {
  margin-bottom: 5px;
}
.clientDetailsRow {
  margin-bottom: 10px;
}
.clientStatusAndImage {
  margin-right: 15px;
}
.stayCard {
  background-color: #ffffff;
  min-width: 800px;
}
.staySelector {
  width: 280px;
}
</style>
